



















import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import { COLORS } from '@/enums/generic'
import { REKORDCLOUD_COLOR_HEX_MAP, DVS_COLORS } from '@/helpers/color'
import { LibraryMixin } from '../mixins'

@Component({})
export default class ColorPicker extends Mixins(LibraryMixin) {
  @Prop()
  value: COLORS

  model: COLORS = this.value

  colorHexMap = REKORDCLOUD_COLOR_HEX_MAP

  get colorName(): string {
    if (!this.model) return 'none'

    return this.model.replace(/_/g, ' ')
  }

  get availableColors(): COLORS[] {
    if (!this.library) return []

    return DVS_COLORS[this.library.importType]
  }

  setColor(c: COLORS): void {
    this.model = c
  }

  @Watch('model')
  emit(): void {
    this.$emit('input', this.model)
  }
}
